import { render, staticRenderFns } from "./CampaignLeaderboardModal.vue?vue&type=template&id=8e4300c2&scoped=true&"
import script from "./CampaignLeaderboardModal.vue?vue&type=script&lang=js&"
export * from "./CampaignLeaderboardModal.vue?vue&type=script&lang=js&"
import style0 from "./CampaignLeaderboardModal.vue?vue&type=style&index=0&id=8e4300c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4300c2",
  null
  
)

export default component.exports